export var l = {
  navbar: {
    HOME: 'home',
    ABOUTUS: 'abount'
  },
  test: {
    content: 'English内容'
  }
};

/* 导航 */
export var navbar = {
  HOME: 'Home',
  ABOUTUS: 'abount',
  TABLE: 'Table',
  FIRST_TABLE: 'first-table',
  TREE: 'Tree',
  FORM: 'Form',
  MENU: 'Menu',
  FIRST_MENU: 'FirstMenu',
  SECOND_MENU: 'SecondMenu',
  LINK: 'Link'
};